import React, { useEffect, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { Brain, ChevronDown } from "lucide-react";

const PAGE_HOME = "/";
const PAGE_TERMS = "/terms.html";
const PAGE_CONTACT = "/contact.html";
const PAGE_IMPRESSUM = "/impressum.html";

const copy = {
  de: {
    langName: "Deutsch",
    heroTitle: "Brain IQ Challenges",
    heroSubtitle: "Brain IQ Games zum Lernen.",
    heroText:
      "Mit Brain IQ Challenges trainierst du Konzentration, Mustererkennung und logisches Denken in kurzen, motivierenden Sessions - ideal fuer den Alltag.",
    cta: "Training starten",
    sections: [
      {
        title: "Gezieltes Gehirntraining",
        text: "Abwechslungsreiche Denkaufgaben helfen dir dabei, mentale Staerke systematisch aufzubauen - klar, verstaendlich und ohne Ablenkung."
      },
      {
        title: "Lernen, wann es dir passt",
        text: "Starte schnell auf deinem Smartphone und integriere das Training flexibel in Pausen, Freizeit oder deinen Arbeitsalltag."
      },
      {
        title: "Motivierend und uebersichtlich",
        text: "Die Inhalte sind auf echten Lernfortschritt ausgelegt - mit klarer Struktur, ruhigem Design und einem Fokus auf das Wesentliche."
      }
    ],
    legalLinks: {
      terms: "AGB",
      contact: "Kontakt",
      impressum: "Impressum"
    },
    disclaimer:
      "Die Bezahlung erfolgt unkompliziert über deine Mobilfunkrechnung. Der komplette Zugang kostet einmalig 15,00 € für 1 Monat (inkl. MwSt.). Kundenservice E-Mail: bazingo.de@silverlines.info Kundenservice Telefonnummer: 08005895405 Dienst bereitgestellt von: Comparo Media d.o.o.",
    backToHome: "Zur Startseite",
    termsTitle: "AGB – Allgemeine Geschäftsbedingungen",
    termsText: [
      "1. Geltungsbereich",
      "Diese Allgemeinen Geschäftsbedingungen (im Folgenden: „AGB\") sind Bestandteil jedes Vertrags zwischen Comparo Media d.o.o. (im Folgenden: „Anbieter\") und dem Nutzer der vom Anbieter bereitgestellten Leistungen. Die AGB gelten gleichermaßen für Rechtsnachfolger des Anbieters sowie des Nutzers.",
      "Der Anbieter stellt dem Nutzer gegen Entgelt die Möglichkeit zur Verfügung, die auf der Webseite angebotenen digitalen Inhalte über sein mobiles Endgerät (Mobiltelefon) abzurufen und zu nutzen. Gegenstand dieser AGB sind sämtliche Regelungen im Zusammenhang mit der Nutzung dieser Leistungen.",
      "Diese AGB gelten ausschließlich für Nutzer mit Wohnsitz in Deutschland.",
      "Die Leistungen des Anbieters erfolgen ausschließlich auf Grundlage dieser AGB. Mit der Inanspruchnahme der Leistungen erkennt der Nutzer diese AGB als verbindlich an.",
      "2. Vertragsschluss",
      "Die Darstellung der Leistungen auf der Webseite des Anbieters stellt kein verbindliches Angebot dar, sondern eine Aufforderung an den Nutzer, ein Angebot abzugeben.",
      "Der Vertrag kommt zustande, sobald der Nutzer auf seinem mobilen Endgerät den angezeigten Bestätigungs- bzw. Abspielbutton aktiviert und der Anbieter daraufhin den Zugang zur Leistung einrichtet.",
      "Nach erfolgreicher Aktivierung kann der Nutzer sämtliche angebotenen Inhalte über sein mobiles Endgerät abrufen und nutzen.",
      "Es gelten die dem Nutzer mitgeteilten Preise. Diese beinhalten die gesetzliche Mehrwertsteuer, gelten für den angegebenen Zeitraum und beziehen sich ausschließlich auf die Nutzungsrechte an den Leistungen des Anbieters. Etwaige Verbindungs- oder Datengebühren, die durch den Mobilfunkanbieter des Nutzers entstehen, sind nicht in den Preisen enthalten.",
      "Das Entgelt wird unmittelbar mit Vertragsschluss ohne Abzug fällig. Die Abrechnung erfolgt im Auftrag des Anbieters über den Mobilfunkanbieter des Nutzers im Rahmen der regulären Mobilfunkrechnung.",
      "Der Nutzer erhält ein einfaches, nicht übertragbares, zeitlich auf die Vertragsdauer begrenztes und örtlich unbeschränktes Nutzungsrecht an den bereitgestellten Leistungen.",
      "3. Zahlungsbedingungen",
      "Es gelten die dem Nutzer kommunizierten Preise einschließlich der gesetzlichen Mehrwertsteuer. Diese Preise gelten für den jeweils angegebenen Abrechnungs- bzw. Nutzungszeitraum. Nicht enthalten sind mögliche Verbindungsgebühren des Mobilfunkanbieters.",
      "Das Nutzungsentgelt wird sofort bei Vertragsschluss fällig und über den Mobilfunkanbieter des Nutzers im Auftrag des Anbieters eingezogen.",
      "4. Nutzungsrechte",
      "Der Nutzer erhält ein einfaches, nicht exklusives, nicht übertragbares und auf die Vertragsdauer begrenztes Nutzungsrecht an den vom Anbieter bereitgestellten Leistungen. Eine Weitergabe oder Verbreitung der Inhalte an Dritte ist nicht gestattet.",
      "5. Erreichbarkeit",
      "Der Anbieter gewährleistet eine durchschnittliche Erreichbarkeit der Leistungen von 99,5 % pro Jahr. Sollte diese Erreichbarkeit unterschritten werden, kann der Nutzer eine angemessene Minderung verlangen. Die Minderung ist der Höhe nach auf den Betrag begrenzt, den der Nutzer für den Zeitraum der eingeschränkten Erreichbarkeit zu zahlen hatte.",
      "Der Anbieter richtet sein Angebot nach gängigen technischen Standards aus, kann jedoch nicht garantieren, dass sämtliche mobilen Endgeräte auf dem Markt die Leistungen fehlerfrei unterstützen.",
      "6. Haftungsbeschränkung / Haftungsfreistellung",
      "Für Schäden, die nicht auf der Verletzung von Leben, Körper oder Gesundheit beruhen, haftet der Anbieter nur bei vorsätzlichem oder grob fahrlässigem Verhalten des Anbieters, seiner Mitarbeitenden oder Erfüllungsgehilfen. Dies gilt auch für Schäden aus der Verletzung von Pflichten im Rahmen von Vertragsverhandlungen oder aus unerlaubten Handlungen."
    ],
    contactTitle: "Kontakt & Hilfe",
    contactText: [
      "Sollten Sie noch Fragen haben, dann können Sie Kontakt mit uns unter bazingo.de@silverlines.info aufnehmen. Bitte vergessen Sie nicht, Ihre Handynummer anzugeben. Wir setzen uns so schnell wie möglich mit Ihnen in Verbindung!",
      "Telefonnummer Helpdesk: 08005895405"
    ],
    impressumTitle: "Impressum",
    impressumText: [
      "Angaben gemäß § 5 TMG",
      "Comparo Media d.o.o.",
      "Ul. Milutina Barača 7",
      "51000 Rijeka",
      "Kroatien",
      "Kontakt",
      "Telefonnummer: 0800 589 5405",
      "E-Mail: bazingo.de@silverlines.info",
      "Umsatzsteuer-ID",
      "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:",
      "HR80948414608"
    ]
  },
  en: {
    langName: "English",
    heroTitle: "Brain IQ Challenges",
    heroSubtitle: "Brain IQ games for learning.",
    heroText:
      "Brain IQ Challenges helps you train concentration, pattern recognition, and logical thinking in short and motivating sessions you can fit into any day.",
    cta: "Start training",
    sections: [
      {
        title: "Focused brain training",
        text: "Engaging exercises support step-by-step improvement of key cognitive skills with clear and practical learning flow."
      },
      {
        title: "Learn on your schedule",
        text: "Use it easily on mobile and continue whenever it fits your routine - during breaks, after work, or in the evening."
      },
      {
        title: "Clean and motivating experience",
        text: "The platform keeps a learning-first structure with simple navigation and clear content focused on meaningful progress."
      }
    ],
    legalLinks: {
      terms: "Terms",
      contact: "Contact",
      impressum: "Imprint"
    },
    disclaimer:
      "Payment is processed conveniently through your mobile phone bill. Full access costs a one-time fee of EUR 15.00 for 1 month (incl. VAT). Customer service email: bazingo.de@silverlines.info Customer service phone: 08005895405 Service provided by: Comparo Media d.o.o.",
    backToHome: "Back to home",
    termsTitle: "Terms & Conditions",
    termsText: copyPlaceholder("Terms are displayed in German as legally provided."),
    contactTitle: "Contact & Help",
    contactText: [
      "If you still have questions, please contact us at bazingo.de@silverlines.info. Please do not forget to include your mobile number. We will get back to you as quickly as possible.",
      "Helpdesk phone number: 08005895405"
    ],
    impressumTitle: "Imprint",
    impressumText: [
      "Information according to Section 5 TMG",
      "Comparo Media d.o.o.",
      "Ul. Milutina Barača 7",
      "51000 Rijeka",
      "Croatia",
      "Contact",
      "Phone: 0800 589 5405",
      "E-Mail: bazingo.de@silverlines.info",
      "VAT ID",
      "VAT identification number according to Section 27 a German VAT Act:",
      "HR80948414608"
    ]
  }
};

function copyPlaceholder(text) {
  return [text];
}

function LegalPage({ title, blocks, lang }) {
  return (
    <main className="page-wrap">
      <div className="container legal-card">
        <h1>{title}</h1>
        {blocks.map((item, index) => (
          <p key={`${item}-${index}`}>{item}</p>
        ))}
        <a className="inline-link" href={PAGE_HOME}>
          {copy[lang].backToHome}
        </a>
      </div>
    </main>
  );
}

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("lp_lang") || "de");
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const [heroImageMissing, setHeroImageMissing] = useState(false);
  const currentPath = window.location.pathname;
  const t = copy[lang] || copy.de;

  useEffect(() => {
    localStorage.setItem("lp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const renderPage = () => {
    if (currentPath === PAGE_TERMS) {
      return <LegalPage title={t.termsTitle} blocks={copy.de.termsText} lang={lang} />;
    }
    if (currentPath === PAGE_CONTACT) {
      return <LegalPage title={t.contactTitle} blocks={t.contactText} lang={lang} />;
    }
    if (currentPath === PAGE_IMPRESSUM) {
      return <LegalPage title={t.impressumTitle} blocks={t.impressumText} lang={lang} />;
    }

    return (
      <main className="page-wrap">
        <section className="hero">
          <div className="container hero-grid">
            <div>
              <p className="eyebrow">{t.heroSubtitle}</p>
              <h1>{t.heroTitle}</h1>
              <p className="hero-text">{t.heroText}</p>
              <a href="/s" className="cta-btn">
                {t.cta}
              </a>
            </div>
            <div className="hero-visual" aria-hidden="true">
              {heroImageMissing ? (
                <div className="hero-fallback-icon">
                  <Brain size={72} />
                </div>
              ) : (
                <img
                  src="/images/hero-brainiq.jpg"
                  alt="Person using brain training games on a smartphone"
                  className="hero-image"
                  onError={() => setHeroImageMissing(true)}
                />
              )}
            </div>
          </div>
        </section>

        <section className="container section-grid">
          {t.sections.map((item) => (
            <article key={item.title} className="card">
              <h2>{item.title}</h2>
              <p>{item.text}</p>
              <a href="/s" className="inline-link">
                {t.cta}
              </a>
            </article>
          ))}
        </section>

        <section className="container disclaimer">
          <h2>Disclaimer</h2>
          <p>{t.disclaimer}</p>
        </section>
      </main>
    );
  };

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="container topbar-inner">
          <a className="brand" href={PAGE_HOME}>
            <Brain size={20} />
            <span>brainiqchallenges.com</span>
          </a>

          <div className="top-actions">
            <nav className="legal-nav">
              <a href={PAGE_TERMS}>{t.legalLinks.terms}</a>
              <a href={PAGE_CONTACT}>{t.legalLinks.contact}</a>
              <a href={PAGE_IMPRESSUM}>{t.legalLinks.impressum}</a>
            </nav>

            <div className="lang-wrap">
              <button
                type="button"
                className="lang-button"
                onClick={() => setLanguageMenuOpen((open) => !open)}
                aria-expanded={languageMenuOpen}
              >
                {lang === "de" ? (
                  <ReactCountryFlag countryCode="DE" svg />
                ) : (
                  <ReactCountryFlag countryCode="GB" svg />
                )}
                <span>{t.langName}</span>
                <ChevronDown size={16} />
              </button>

              {languageMenuOpen && (
                <div className="lang-menu">
                  <button type="button" onClick={() => setLang("de")}>
                    <ReactCountryFlag countryCode="DE" svg />
                    <span>Deutsch</span>
                  </button>
                  <button type="button" onClick={() => setLang("en")}>
                    <ReactCountryFlag countryCode="GB" svg />
                    <span>English</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {renderPage()}

      <footer className="footer">
        <div className="container footer-inner">
          <p>© {new Date().getFullYear()} Comparo Media d.o.o.</p>
          <a href="/s" className="inline-link">
            {t.cta}
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
